import { ButtonPrimary } from "components/Atoms/Button";
import moment from "moment";
import React from "react";
import { formatTime, formatWrittenDayMonthYear } from "utilities";
import { formatArrivalTime } from "shared/utils/flightUtils";

interface Props {
  data: server.dto.ScheduledFlightFromFlightStats
  onSelect: (flight: server.dto.ScheduledFlightFromFlightStats) => void
}

export const FlightSearchResult = (props: Props) => {
  const depart = moment.utc(props.data.departureLocal);
  const arrive = moment.utc(props.data.arrivalLocal);

  return <div onClick={() => props.onSelect(props.data)} className="flex gap padding-larger radius hoverable card-floating-bg">
    <div className=" grow1 flex-column">
      <div>{props.data.flightDesignator}</div>
      <div>{formatWrittenDayMonthYear(depart)}</div>
    </div>

    <div style={{ width: 250 }} className="flex-column">
      <div>{formatTime(depart)}</div>
      <div>{props.data.departureAirport.iata}</div>
      <div>{props.data.departureAirport.name}</div>
      <div>{props.data.departureAirport.location}</div>
    </div>

    <div>
      <div className="icon-arrow-right"></div>
    </div>

    <div style={{ width: 250 }} className="flex-column">
      <FormatArrivalTime departure={depart} arrival={arrive} />
      <div>{props.data.arrivalAirport.iata}</div>
      <div>{props.data.arrivalAirport.name}</div>
      <div>{props.data.arrivalAirport.location}</div>
    </div>

    <div>
      <ButtonPrimary
        label={RESX.Buttons.btnSelect}
        onClick={() => { }}
      />
    </div>
  </div>
}

interface FormatArrivalTimeProps {
  departure: moment.Moment
  arrival: moment.Moment
}

export const FormatArrivalTime = ({ departure, arrival }: FormatArrivalTimeProps) => {
  const [isSameDay, timeDiffInDays, sign] = formatArrivalTime(departure, arrival);

  return <div>
    {formatTime(arrival)}
    {!isSameDay && <span><sup>&nbsp;{sign}{timeDiffInDays}</sup></span>}
  </div>
}